import { service } from '../axios';
export function getFormViewPageDyn(params) {
    return service({
        url: '/form/getFormViewPage',
        method: 'get',
        params
    });
}
export function getViewListDyn(params) {
    return service({
        url: '/form/getViewList',
        method: 'get',
        params
    });
}
export function batchSubmitFormDyn(data) {
    return service({ url: '/form/batchSubmitForm', method: 'post', data });
}
export function submitFormDyn(data) {
    return service({ url: '/form/submitForm', method: 'post', data });
}
export function getFormViewFieldsDyn(params) {
    return service({
        url: '/form/getFormViewFields',
        method: 'get',
        params
    });
}
export function getFormDataOneDyn(params) {
    return service({
        url: '/form/getFormDataOne',
        method: 'get',
        params
    });
}
export function deleteFormDataDyn(params) {
    return service({
        url: '/form/deleteFormData',
        method: 'post',
        params
    });
}
export function getFormDyn(params) {
    return service({
        url: '/form/getForm',
        method: 'get',
        params
    });
}
export function getFormFieldsDyn(params) {
    return service({
        url: '/form/getFormFields',
        method: 'get',
        params
    });
}
/* 获取角色权限矩阵 */
export function getRoleMatrix(params) {
    return service({
        url: '/actionPermission/getRoleMatrix',
        method: 'get',
        params
    });
}
export function getAllForms() {
    return service({
        url: '/actionPermission/getAllForms',
        method: 'get'
    });
}
/* 保存角色权限矩阵 */
export function saveRoleMatrix(data) {
    return service({
        url: '/actionPermission/saveRoleMatrix',
        method: 'post',
        data
    });
}
